import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/layout";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import ForgotPasswordPage from "./pages/ForgotPassword";
import UserDashboard from "./pages/User";
import UserDetailPage from "./pages/UserDetail";
import UserCreatePage from "./pages/UserCreate";
import SettingsPage from "./pages/Settings";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import "./App.css";
import SmartCallback from "./pages/SmartCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import PatientDashboard from "./pages/Patient";
import PatientDetail from "./pages/PatientDetail";
import OrgPage from "./pages/OrgPage";

const App: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Navigate to="/patients" replace />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/user" element={<UserDashboard />} />
        <Route path="/smart/callback" element={<SmartCallback />} />
        <Route path="/user/new" element={<UserCreatePage />} />
        <Route path="/user/:id" element={<UserDetailPage />} />
        <Route path="/patients" element={<PatientDashboard />} />
        <Route path="/patients/:id" element={<PatientDetail />} />
        <Route path="/organizations" element={<OrgPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/terms" element={<TermsOfService />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default App;
